/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserResponse } from '../../models/user-response';

export interface GetUsersByCustomerId$Params {
  customerId: number;
}

export function getUsersByCustomerId(http: HttpClient, rootUrl: string, params: GetUsersByCustomerId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserResponse>>> {
  const rb = new RequestBuilder(rootUrl, getUsersByCustomerId.PATH, 'get');
  if (params) {
    rb.query('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserResponse>>;
    })
  );
}

getUsersByCustomerId.PATH = '/api/user';
